import React from 'react';
import { AppGridLayout, AppTableSearch, AppSearchItem, AppTable, AppRow, AppButton } from 'qcc';
import { AppAction, AppGridBar } from 'qcc';
import api, { } from "api";
import DeviceEditForm from './DeviceEditForm'

export default class extends React.Component {
  state = {}
  add = async () => {
    let projectId = 0;
    if (this.refTableSearch.current)
      projectId = (this.refTableSearch.current.state.data.projectId) || 0;
    if (projectId === 0) return;
    let title = '新增POS设备';
    let formData = { project_id: projectId };
    let editForm = <DeviceEditForm mode={1} formData={formData} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title ,height:350});
  }

  edit = async (data?: any) => {
    let title = '编辑POS设备';
    let editForm = <DeviceEditForm mode={1} formData={{ ...data }} afterSave={this.afterSave} />
    AppAction.openDialog(editForm, { title,height:350 });
  }



  delete = async (data?: any) => {
    if (await AppAction.deleteConfirm('您确定要删除该记录吗？')) {
      await api.posdevice.delete({ id: data.id });
      AppAction.successMsg('删除成功！');
      this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    }
  }

  afterSave = () => {
    this.refGrid.current && this.refGrid.current.state.refTable.fetch();
    AppAction.closeDialog();
  }

  refGrid = React.createRef<AppGridLayout>();
  refTableSearch = React.createRef<AppTableSearch>();

  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.SearchArea>
          <AppTableSearch ref={this.refTableSearch}>
            <AppTableSearch.Common>
              <AppSearchItem.ProjectTree keyName='projectId' projectTreeScene={6601} field='project_id' lable='项目：' />
            </AppTableSearch.Common>
          </AppTableSearch>
        </AppGridLayout.SearchArea>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Right>
              <AppButton label='新增' actionCode="66201001" type='primary' action={this.add} />
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable paging onBeforeApi={(data?: any) => { return data.projectId !== undefined }} sqlId='sql.pos.deviceGrid' >
            <AppTable.ColIndex />
            <AppTable.Col title='POS设备S/N码' field='mac' width={300} />
            <AppTable.Col title='设备名称' field='name' width={300} />
            <AppTable.Col title='对应版本' field='version' width={300} />
            <AppTable.Col title='备注' field='remark' width={300} />
            <AppTable.ColAction render={(data: any, dataIndex: number) => {
              return (<AppRow itemSplit={10} style={{ float: 'right' }}>
                <AppButton type='link' label='编辑' actionCode="66201002" action={() => this.edit(data)} />
                <AppButton type='link' label='删除' actionCode="66201003" action={() => this.delete(data)} />
              </AppRow>);
            }} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/pos/device/DeviceGird.tsx